var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.disabled ? 'disabled' : '',
    _vm.wide ? 'wide' : '',
    _vm.downArrows ? 'down-arrows' : '',
    'll-button',
    _vm.classes,
  ],attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.downArrows)?_c('span',{staticClass:"down-arrow left"},[_c('DoubleArrows')],1):_vm._e(),_vm._t("default"),(_vm.downArrows)?_c('span',{staticClass:"down-arrow right"},[_c('DoubleArrows')],1):_vm._e(),(_vm.arrows)?_c('span',{staticClass:"arrows"},[_c('DoubleArrows')],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }